// Mock data for PLANETE FOOD restaurant

export const restaurantInfo = {
  name: "PLANETE FOOD",
  tagline: "Cuisine du monde – Afro-food, burgers, grillades & street-food",
  location: "Massy",
  address: "58 avenue Raymond Aron, 91300 Massy",
  phones: [
    { number: "07 68 30 46 56", link: "tel:+33768304656" },
    { number: "01 69 30 78 53", link: "tel:+33169307853" }
  ],
  badges: ["Sur place", "À emporter", "Livraison", "Halal"],
  openingHours: {
    "Lundi": "11:00 – 00:00",
    "Mardi": "11:00 – 00:00",
    "Mercredi": "11:00 – 00:00",
    "Jeudi": "11:00 – 00:00",
    "Vendredi": "11:00 – 00:00",
    "Samedi": "12:00 – 00:00",
    "Dimanche": "12:00 – 00:00"
  },
  openingNote: "Ouvert 7/7"
};

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_urbanafrofood/artifacts/onbx1zdw_bur.png",
    alt: "Burger gourmand",
    category: "Burgers"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_urbanafrofood/artifacts/fazsrr04_assiette.png",
    alt: "Assiette africaine",
    category: "Assiettes Africaines"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_urbanafrofood/artifacts/y2gsuevu_2025-02-19%20%282%29.png",
    alt: "Nos spécialités",
    category: "Spécialités"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_urbanafrofood/artifacts/p45xy3bp_2025-0.png",
    alt: "Nos plats savoureux",
    category: "Plats"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_urbanafrofood/artifacts/dh53i927_2025-02-1%29.png",
    alt: "Délices maison",
    category: "Délices"
  }
];

export const menuData = {
  burgers: {
    title: "Burgers",
    subtitle: "servis avec frites",
    items: [
      { name: "Cheeseb New-York", description: "Steak haché, cheddar, cornichon, ketchup", price: "8,00 €" },
      { name: "Burger Dallas", description: "2 steaks hachés, cheddar, œuf, salade, tomate, oignons", price: "8,50 €" },
      { name: "Burger Los-Angeles", description: "Steak poulet, cheddar, œuf, salade, tomate, oignons", price: "8,50 €" }
    ]
  },
  africanDishes: {
    title: "Assiettes africaines",
    items: [
      { name: "Thieb poulet Dakar", description: "Riz rouge, sauce tomate, chou blanc, carottes, poulet", price: "11,50 €" },
      { name: "Thieb poisson de Mbour", description: "Riz rouge, sauce tomate, chou blanc, carottes, poisson", price: "13,00 €" },
      { name: "Yassa poulet Ziguinchor", description: "Riz blanc, sauce aux oignons, olives vertes, poulet", price: "11,50 €" },
      { name: "Mafé bœuf Bamako", description: "Riz blanc, sauce arachide, morceaux de bœuf", price: "13,00 €" },
      { name: "Mafé poulet Conakry", description: "Riz blanc, sauce arachide, cuisse de poulet", price: "11,50 €" }
    ]
  },
  grillades: {
    title: "Grillades",
    subtitle: "accompagnement au choix",
    items: [
      { name: "Poulet braisé Ouagadougou", description: "Poulet braisé", price: "12,00 €" },
      { name: "Côte d'agneau braisée", description: "Côte d'agneau braisée", price: "17,00 €" },
      { name: "Poisson braisé", description: "Poisson braisé", price: "16,00 €" },
      { name: "Dibi d'agneau braisé", description: "Dibi d'agneau braisé", price: "17,00 €" },
      { name: "Brochettes de bœuf Bandal (x3)", description: "Brochettes de bœuf", price: "16,00 €" },
      { name: "Brochettes de poulet Cotonou (x3)", description: "Brochettes de poulet", price: "13,00 €" }
    ]
  },
  accompagnements: {
    title: "Accompagnements",
    items: [
      { name: "Riz blanc" },
      { name: "Riz rouge" },
      { name: "Penne basilic" },
      { name: "Frites classiques" },
      { name: "Frites cheddar" },
      { name: "Frites cheddar bacon" },
      { name: "Frites de patates douces" },
      { name: "Bananes plantain" },
      { name: "Haricots verts" }
    ]
  },
  sandwiches: {
    title: "Sandwichs",
    subtitle: "servis avec frites – sauce au choix",
    items: [
      { name: "Kebab Istanbul", description: "Viande kebab, salade, tomate, oignons", price: "7,50 €" },
      { name: "Sandwich Marseille", description: "Cordon bleu, 2 steaks hachés, cheddar, salade, tomate, oignons", price: "9,50 €" },
      { name: "Sandwich Sydney", description: "3 steaks hachés, œuf, bacon, cheddar", price: "9,50 €" },
      { name: "Sandwich Athènes", description: "Poulet, boursin, salade, tomate, oignons", price: "8,50 €" },
      { name: "Sandwich Jakarta", description: "Poulet curry, cheddar, salade, tomate, oignons", price: "8,50 €" },
      { name: "Sandwich New Delhi", description: "Poulet tenders, salade, tomate, oignons", price: "8,50 €" }
    ]
  },
  bokits: {
    title: "Bokits",
    subtitle: "servis avec frites & boisson",
    sauces: "Sauces au choix : chien, moutarde, mayonnaise, BBQ, ketchup, algérienne, andalouse",
    items: [
      { name: "Bokit Pointe-à-Pitre", description: "Salade, tomates, oignons, steak, œuf, bacon", price: "9,50 €" },
      { name: "Bokit Fort-de-France", description: "Salade, tomates, oignons, poulet mariné", price: "9,00 €" },
      { name: "Bokit Sainte-Anne", description: "Salade, tomate, oignons, jambon, fromage", price: "8,00 €" }
    ]
  },
  pastas: {
    title: "Pastas",
    items: [
      { name: "Penne Foresta", description: "Sauce fromagère, poulet, champignons", price: "9,00 €" },
      { name: "Penne Bolognaise", description: "Sauce tomate, viande hachée", price: "9,00 €" },
      { name: "Penne Salmone", description: "Crème fraîche, saumon", price: "9,00 €" },
      { name: "Penne Carbonara", description: "Sauce fromagère, lardons", price: "9,00 €" },
      { name: "Penne Fromage", description: "Raclette, reblochon, parmesan", price: "8,00 €" },
      { name: "Penne Basilic", description: "Sauce tomate, basilic, olives", price: "8,00 €" }
    ]
  },
  salads: {
    title: "Salades",
    items: [
      { name: "Salade César", description: "Salade, emmental, poulet, œuf, tomates cerises, sauce César", price: "8,00 €" }
    ]
  },
  pizzas: {
    title: "Ton Picini (mini pizzas)",
    items: [
      { name: "Picopollo", description: "Crème fraîche, poulet, champignons, boursin, mozzarella", price: "8,00 €" },
      { name: "Picotonno", description: "Crème fraîche, artichauts, thon, olives, mozzarella", price: "8,00 €" },
      { name: "Pissaka", description: "Sauce tomate, viande hachée, aubergines, oignons, mozzarella", price: "8,00 €" },
      { name: "Picante", description: "Sauce piquante, viande hachée, chorizo, poivrons, mozzarella", price: "8,00 €" },
      { name: "Salmerino", description: "Crème d'asperge, saumon, courgettes, mozzarella", price: "8,00 €" },
      { name: "Chevroni", description: "Crème fraîche, miel, poulet, chèvre, mozzarella", price: "8,00 €" },
      { name: "Vegoni", description: "Sauce tomate, artichauts, olives, aubergines, poivrons, mozzarella", price: "8,00 €" },
      { name: "Americoni", description: "Sauce tomate, merguez, bacon, olives, mozzarella", price: "8,00 €" },
      { name: "Tartuffi", description: "Crème de truffe, lardons, pommes de terre, mozzarella", price: "8,00 €" }
    ]
  },
  pizzeta: {
    title: "Pizzeta",
    subtitle: "1 base + 1 garniture + 1 légume – 5,00 €",
    bases: ["sauce tomate", "crème fraîche", "barbecue"],
    garnitures: ["poulet", "viande hachée", "merguez", "thon", "bacon", "jambon", "lardons"],
    legumes: ["poivrons", "pommes de terre", "champignons", "courgettes", "artichauts", "oignons", "olives", "aubergines"]
  },
  kidsMenu: {
    title: "Menu Kids",
    items: [
      { name: "Menu Kids", description: "4 nuggets ou 2 tenders + Frites + Capri-Sun" }
    ]
  },
  extras: {
    title: "Extras",
    items: [
      { name: "Frites", price: "2,50 €" },
      { name: "Frites cheddar", price: "3,00 €" },
      { name: "Frites cheddar bacon", price: "3,50 €" },
      { name: "Frites patates douces", price: "3,50 €" },
      { name: "Wings (x5)", price: "5,00 €" },
      { name: "Tenders (x4)", price: "6,00 €" },
      { name: "Bananes plantain", price: "3,50 €" },
      { name: "Pastels (x3)", price: "5,00 €" }
    ]
  }
};
